import React, { useState } from 'react';
import DepositMethod from './DepositMethod';
import CryptoDeposit from './CryptoDeposit';
import BankDeposit from './BankDeposit';
import BackButton from '../../components/common/UI/BackButton';
import './Deposit.css';

const Deposit = () => {
  const [currentStep, setCurrentStep] = useState('method');
  const [selectedMethod, setSelectedMethod] = useState(null);

  const handleMethodSelect = (method) => {
    setSelectedMethod(method);
    setCurrentStep('deposit');
  };

  const handleBack = () => {
    if (currentStep === 'deposit') {
      setCurrentStep('method');
      setSelectedMethod(null);
    }
  };

  const handleDepositSuccess = () => {
    setCurrentStep('method');
    setSelectedMethod(null);
  };

  return (
    <div className="deposit-page">
      <div className="deposit-container">
        {/* Header */}
        <div className="deposit-header">
          {currentStep === 'deposit' && (
            <BackButton onClick={handleBack} />
          )}
          <h1>
            {currentStep === 'method' ? 'Choose Top-Up Method' : 
             selectedMethod === 'crypto' ? 'Crypto' : 'Bank Transfer'}
          </h1>
        </div>

        

        {/* Content */}
        <div className="deposit-content">
          {currentStep === 'method' && (
            <DepositMethod onMethodSelect={handleMethodSelect} />
          )}
          
          {currentStep === 'deposit' && selectedMethod === 'crypto' && (
            <CryptoDeposit onSuccess={handleDepositSuccess} />
          )}
          
          {currentStep === 'deposit' && selectedMethod === 'bank' && (
            <BankDeposit onSuccess={handleDepositSuccess} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Deposit;